<template>
    <div class="consultation-header">
        <div class="header-first">
             <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>双向转诊</span></div>
        </div>
        <div class="header-second">
             <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品简介</span></div>
             <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;">双向转诊是医共体和医联体中上下级医院之间患者转诊管理系统，下级医院对于诊断、治疗困难的患者可以申请转至上级医院，上级医院可以对病
         </div>
             <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">情稳定和康复阶段患者转至下级医院，以更加有效的达成分级诊疗的目标。 在转诊时需要填写患者的病历、检查报告和住院报告等详细信息以便于转到的
         </div>
             <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">医院进一步治疗，同时转诊后的治疗结果也需要更新到系统中，以便于转诊前的医院对患者的情况做一个跟踪。 </div>
             <div style="margin-top:25px">
                <img src="@/assets/image/zhuanzhen.png" alt="">
             </div>
         </div>
         <div class="header-firth" style="margin-top:25px">
             <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>业务流程</span></div>
             <div style="margin-top:25px">
                 <img src="@/assets/image/zhuanzhen1.png" alt="">
            </div>
         </div>
     </div>
 </template>

 <script>
     export default {
             }
 </script>

 <style lang="scss">
     .consultation-header{
         width: 100%;
         padding-left: 20px;
         .header-forth{
             margin-right:70px;
         }

    }
 </style>